module.exports = __webpack_public_path__ + "static/img/icon_program-1.5192112b.svg";